export default __webpack_public_path__ + "static/media/ems_backup.a7a3de0d.svg";